import {EmployeeRoleEnum} from "../../../domain/enum/employee-role.enum";
import {TranslationServiceInterface} from "../../translation-service.interface";
import {ServiceLine} from "../../../domain/in/quote/service-line";
import {ServiceLineSummary} from "../../../domain/out/service-line-summary";
import {SynthesisServiceFactory} from "./synthesis-service.factory";
import {QuoteService} from "../../../domain/in/quote/quote-service";

export class SynthesisServiceProxy {

    constructor(
        protected translationService: TranslationServiceInterface) {
    }

    public async getQuoteServiceSummary(currency: string, eForceRoleCode: string, view: string, locale: string, service?: QuoteService) {
        const role = EmployeeRoleEnum.getEmployeeRoleEnumFromEforceRole(eForceRoleCode);

        return SynthesisServiceFactory.getSynthesisService(role, this.translationService).getQuoteServiceSummary(currency, eForceRoleCode, view, locale, service);
    }

    public async getServiceLineSummary(
        serviceLine: ServiceLine,
        eForceRole: string,
        currency: string,
        view: string,
        locale: string
    ): Promise<ServiceLineSummary> {
        let employeeRoleEnumFromEforceRole = EmployeeRoleEnum.getEmployeeRoleEnumFromEforceRole(eForceRole);

        return SynthesisServiceFactory.getSynthesisService(employeeRoleEnumFromEforceRole, this.translationService).getServiceLineSummary(serviceLine, eForceRole, currency, view, locale)
    }

}
